<template>
	<div class="step4">
		<div class="step4__footer">
			<button class="btn-beltone xl" :class="{'disabled': submitting}" @click="prevStep()">Back</button>
			<button class="btn-beltone xl" :class="{'disabled': submitting}" @click="complete()">
				<div v-show="submitting" class="btn-spinner">
					<div class="outer"><div class="inner"><span></span></div></div>
				</div>
				<span :class="{'hidden': submitting}">Schedule</span>
			</button>
		</div>
		<div class="step4__content">
			<p class="step4__header">Please verify the information below is correct.</p>
      <p class="step4__subheader">
        <IconMapMarker color="#00BAF2"/>
        <span>Appointment Location</span>
        <strong>{{ displayClinicAddress }}</strong>
      </p>
      <div class="step4__details">
        <div class="step4__item">
          <IconCheck color="#00BAF2"/>
          <div class="step4__item-content">
            <p class="step4__item-title">Appointment Type</p>
            <strong class="step4__item-value">{{ displayAppointmentType[0] }}</strong>
            <strong class="step4__item-value">{{ displayAppointmentType[1] }}</strong>
          </div>
        </div>
        <div class="step4__item">
          <IconCalendar color="#00BAF2"/>
          <div class="step4__item-content">
            <p class="step4__item-title">Appointment Date</p>
            <strong class="step4__item-value">{{ displayAppointmentDate }}</strong>
          </div>
        </div>
        <div class="step4__item">
          <IconPerson color="#00BAF2"/>
          <div class="step4__item-content">
            <p class="step4__item-title">Patient Name</p>
            <strong class="step4__item-value">{{ patient.firstName }} {{ patient.lastName }}</strong>
          </div>
        </div>
        <div class="step4__item">
          <IconClock color="#00BAF2"/>
          <div class="step4__item-content">
            <p class="step4__item-title">Appointment Time</p>
            <strong class="step4__item-value">{{ displayAppointmentTime }}</strong>
          </div>
        </div>
        <div class="step4__item">
          <IconPhone color="#00BAF2"/>
          <div class="step4__item-content">
            <p class="step4__item-title">Patient Phone</p>
            <strong class="step4__item-value">{{ patient.phoneNumber }}</strong>
          </div>
        </div>
        <div class="step4__item">
          <IconEnvelope color="#00BAF2"/>
          <div class="step4__item-content">
            <p class="step4__item-title">Patient Email</p>
            <strong class="step4__item-value">{{ patient.emailAddress }}</strong>
          </div>
        </div>
	      <fieldset>
		      <input placeholder="Verify Email Address*"
		             type="email"
		             tabindex="3"
		             required
		             class="emailAddressVerify"
		             v-model="form.emailAddressVerify">
	      </fieldset>
<!--        <template v-if="patient.bringingFamiliarVoice">-->
<!--          <div class="step4__item">-->
<!--            <div class="step4__item-content">-->
<!--              <p class="step4__item-title">Familiar Voice</p>-->
<!--              <strong class="step4__item-value">{{ patient.familiarVoiceFirstName }} {{ patient.familiarVoiceLastName}}</strong>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="step4__item">-->
<!--            <div class="step4__item-content">-->
<!--              <p class="step4__item-title">Familiar Voice Relation</p>-->
<!--              <strong class="step4__item-value">{{ patient.relation.name }}</strong>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
      </div>
    </div>
	</div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import Services from '../../mixins/services';
import IconMapMarker from "../../icons/icon-map-marker.vue";
import IconCheck from "../../icons/icon-check.vue";
import IconCalendar from "../../icons/icon-calendar.vue";
import IconPerson from "../../icons/icon-person.vue";
import IconClock from "../../icons/icon-clock.vue";
import IconPhone from "../../icons/icon-phone.vue";
import IconEnvelope from "../../icons/icon-envelope.vue";

export default {
  components: {
    IconMapMarker,
    IconCheck,
    IconCalendar,
    IconPerson,
    IconClock,
    IconPhone,
    IconEnvelope
  },
	mixins: [Services],
  props: ['dealerId'],
	data: function () {
		return {
			submitting: false,
			recaptchaSiteKey: "6Le-5TIrAAAAAPx8Rmyk5V42XLxrp8_TBXO9XLog",
			recaptchaResponse: '',
			recaptchaRendered: false,
			recaptchaSuccess: true,
			form: {
				emailAddressVerify: ''
			},
		}
	},
	computed: mapState({
    loadedDate: state => state.Globals.loadedDate,
		patient: state => state.OnlineScheduling.patient,
		clinic: state => state.OnlineScheduling.clinic,
		appointmentType: state => state.OnlineScheduling.appointmentType,
		timeslot: state => state.OnlineScheduling.timeslot,
		clientToken: state => state.ClientToken.clientToken,
		displayAppointmentType() {
			if (this.appointmentType === 'FollowUp') {
        return ["Current Patient", "Follow Up (30 min)"]
			} else {
        return ["New Patient", "Free Consultation (90min)"]
			}
		},
		displayClinicAddress() {
			if (this.clinic) {
				return `${this.clinic.address}, ${this.clinic.city}, ${this.clinic.state} ${this.clinic.zipCode}`
			} else {
				return '';
			}
		},
		displayAppointmentDate() {
			return this.helpers().formatterLongDate(this.timeslot.dateTime)
		},
		displayAppointmentTime() {
			return this.helpers().formatterTime(this.timeslot.dateTime)
		}
	}),
	methods: {
    ...mapMutations('OnlineScheduling', { setStateValue: 'setStateValue' }),
		...mapActions('OnlineScheduling', {
      postScheduleAppointment: 'postScheduleAppointment',
      resetData: 'resetData',
    }),
		// onCaptchaVerified(response) {
		// 	this.recaptchaSuccess = true;
		// 	this.recaptchaResponse = response;
		// },
		// onCaptchaExpired() {
		// 	this.recaptchaSuccess = false;
		// 	this.recaptchaResponse = null;
		// },
		prevStep() {
			if (this.submitting) return;

			this.recaptchaSuccess = false;
      this.setStateValue({ key: 'step', value: 3 });
		},
		complete() {
			if (this.submitting) return;

			this.recaptchaSuccess = true;

			//if (!this.recaptchaResponse) {
			//	this.recaptchaSuccess = false;
			//	return false;
			//}

			this.submitting = true;
			let data = {
				recaptchaToken: this.recaptchaResponse,
        emailAddress: this.patient.emailAddress,
				emailAddressVerify: this.form.emailAddressVerify,
				pageLoadedAtUtc: this.loadedDate,
				firstName: this.patient.firstName,
				lastName: this.patient.lastName,
				phoneNumber: this.patient.phoneNumber,
				appointmentType: this.appointmentType,
				dateTime: this.timeslot.dateTime,
				staffId: this.timeslot.staffId,
				clinicId: this.clinic.id,
				clinic: this.clinic,
				isBringingFamiliarVoice: this.patient.bringingFamiliarVoice,
				familiarVoiceFirstName: this.patient.familiarVoiceFirstName,
				familiarVoiceLastName: this.patient.familiarVoiceLastName,
				companionTypeId: this.patient.relation ? this.patient.relation.id : null,
        utmSource: sessionStorage.getItem('utm_source'),
        utmMedium: sessionStorage.getItem('utm_medium'),
        utmCampaign: sessionStorage.getItem('utm_campaign'),
        utmContent: sessionStorage.getItem('utm_content'),
        referrerUrl: sessionStorage.getItem('referrer_url')
			}
			
			this.postScheduleAppointment({
				data,
        dealerId: this.dealerId,
				clientToken: this.clientToken,
				cb: () => {
          this.resetData();
          window.location.href = '/thank-you-online-schedule';
        }
			})
		},
	},
	mounted() {
		// const checkRecaptcha = () => {
		// 	if (window.grecaptcha && window.grecaptcha.render && this.$refs.recaptcha) {
		// 		if (!this.recaptchaRendered) {
		// 			console.log("Rendering reCAPTCHA...");
		// 			window.grecaptcha.render(this.$refs.recaptcha, {
		// 				sitekey: this.recaptchaSiteKey,
		// 				callback: this.onCaptchaVerified,
		// 				'expired-callback': this.onCaptchaExpired
		// 			});
		// 			this.recaptchaRendered = true;
		// 		}
		// 	} else {
		// 		console.log("Waiting for reCAPTCHA or ref to be ready...");
		// 		setTimeout(checkRecaptcha, 500);
		// 	}
		// };
    //
		// checkRecaptcha();
	}
}
</script>
